module.exports = __webpack_public_path__ + "img/1-3.1c996bf5.webp";